<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library as fontAwesomeIconLibrary } from '@fortawesome/fontawesome-svg-core'
import camelCase from 'lodash/camelCase'

// https://fontawesome.com/icons
fontAwesomeIconLibrary.add(
  // Add new icons to this list as you need them
  require('@fortawesome/free-solid-svg-icons/faSync').definition,
  require('@fortawesome/free-solid-svg-icons/faUser').definition,
  require('@fortawesome/free-solid-svg-icons/faArrowLeft').definition,
  require('@fortawesome/free-solid-svg-icons/faArrowsAltH').definition,
  require('@fortawesome/free-solid-svg-icons/faBars').definition,
  require('@fortawesome/free-solid-svg-icons/faBed').definition,
  require('@fortawesome/free-solid-svg-icons/faBolt').definition,
  require('@fortawesome/free-solid-svg-icons/faBookOpen').definition,
  require('@fortawesome/free-solid-svg-icons/faBox').definition,
  require('@fortawesome/free-solid-svg-icons/faBuilding').definition,
  require('@fortawesome/free-solid-svg-icons/faBullseye').definition,
  require('@fortawesome/free-solid-svg-icons/faBus').definition,
  require('@fortawesome/free-solid-svg-icons/faCheck').definition,
  require('@fortawesome/free-solid-svg-icons/faChevronCircleRight').definition,
  require('@fortawesome/free-solid-svg-icons/faChevronCircleDown').definition,
  require('@fortawesome/free-solid-svg-icons/faClock').definition,
  require('@fortawesome/free-solid-svg-icons/faComment').definition,
  require('@fortawesome/free-solid-svg-icons/faCompass').definition,
  require('@fortawesome/free-solid-svg-icons/faDollarSign').definition,
  require('@fortawesome/free-solid-svg-icons/faExclamationTriangle').definition,
  require('@fortawesome/free-solid-svg-icons/faFemale').definition,
  require('@fortawesome/free-solid-svg-icons/faGraduationCap').definition,
  require('@fortawesome/free-solid-svg-icons/faHandshake').definition,
  require('@fortawesome/free-solid-svg-icons/faHome').definition,
  require('@fortawesome/free-solid-svg-icons/faHospital').definition,
  require('@fortawesome/free-solid-svg-icons/faUniversity').definition,
  require('@fortawesome/free-solid-svg-icons/faMale').definition,
  require('@fortawesome/free-solid-svg-icons/faMapMarker').definition,
  require('@fortawesome/free-solid-svg-icons/faMoon').definition,
  require('@fortawesome/free-solid-svg-icons/faParking').definition,
  require('@fortawesome/free-solid-svg-icons/faPhone').definition,
  require('@fortawesome/free-solid-svg-icons/faPrescriptionBottle').definition,
  require('@fortawesome/free-solid-svg-icons/faPrint').definition,
  require('@fortawesome/free-solid-svg-icons/faQuestion').definition,
  require('@fortawesome/free-solid-svg-icons/faRedo').definition,
  require('@fortawesome/free-solid-svg-icons/faShower').definition,
  require('@fortawesome/free-solid-svg-icons/faShoppingBag').definition,
  require('@fortawesome/free-solid-svg-icons/faShoppingCart').definition,
  require('@fortawesome/free-solid-svg-icons/faSignInAlt').definition,
  require('@fortawesome/free-solid-svg-icons/faSignOutAlt').definition,
  require('@fortawesome/free-solid-svg-icons/faSnowflake').definition,
  require('@fortawesome/free-solid-svg-icons/faSun').definition,
  require('@fortawesome/free-solid-svg-icons/faSync').definition,
  require('@fortawesome/free-solid-svg-icons/faTimes').definition,
  require('@fortawesome/free-solid-svg-icons/faTimesCircle').definition,
  require('@fortawesome/free-solid-svg-icons/faToolbox').definition,
  require('@fortawesome/free-solid-svg-icons/faTShirt').definition,
  require('@fortawesome/free-solid-svg-icons/faTree').definition,
  require('@fortawesome/free-solid-svg-icons/faUser').definition,
  require('@fortawesome/free-solid-svg-icons/faUserMd').definition,
  require('@fortawesome/free-solid-svg-icons/faUsers').definition,
  require('@fortawesome/free-solid-svg-icons/faUtensils').definition,
  require('@fortawesome/free-solid-svg-icons/faWheelchair').definition,
  require('@fortawesome/free-solid-svg-icons/faPlug').definition,
  require('@fortawesome/free-solid-svg-icons/faPaw').definition,
  require('@fortawesome/free-solid-svg-icons/faCalendar').definition,
  require('@fortawesome/free-solid-svg-icons/faMoneyBill').definition,
  require('@fortawesome/free-solid-svg-icons/faMoneyBillAlt').definition,
  require('@fortawesome/free-solid-svg-icons/faComments').definition,
  require('@fortawesome/free-solid-svg-icons/faSmoking').definition,
  require('@fortawesome/free-solid-svg-icons/faVolumeUp').definition,
  require('@fortawesome/free-solid-svg-icons/faFilePdf').definition,
  require('@fortawesome/free-solid-svg-icons/faExternalLinkAlt').definition,
  require('@fortawesome/free-solid-svg-icons/faInfoCircle').definition,
  require('@fortawesome/free-solid-svg-icons/faFileDownload').definition,
  require('@fortawesome/free-solid-svg-icons/faCog').definition,
  require('@fortawesome/free-solid-svg-icons/faImages').definition,
  require('@fortawesome/free-solid-svg-icons/faMapMarkedAlt').definition,
  require('@fortawesome/free-solid-svg-icons/faShuttleVan').definition,
  require('@fortawesome/free-solid-svg-icons/faMapMarkerAlt').definition,
  require('@fortawesome/free-solid-svg-icons/faEnvelope').definition,
  require('@fortawesome/free-solid-svg-icons/faMap').definition,
  require('@fortawesome/free-solid-svg-icons/faLayerGroup').definition,
  require('@fortawesome/free-solid-svg-icons/faRoad').definition,
  require('@fortawesome/free-solid-svg-icons/faGlobeAmericas').definition,
  require('@fortawesome/free-solid-svg-icons/faStopCircle').definition
)

export default {
  components: {
    FontAwesomeIcon,
  },
  inheritAttrs: false,
  props: {
    source: {
      type: String,
      default: 'font-awesome',
    },
    name: {
      type: String,
      required: true,
    },
  },
  computed: {
    // Gets a CSS module class, e.g. iconCustomLogo
    customIconClass() {
      return this.$style[camelCase('icon-custom-' + this.name)]
    },
  },
}
</script>

<template>
  <FontAwesomeIcon
    v-if="source === 'font-awesome'"
    v-bind="$attrs"
    :icon="name"
  />
  <span
    v-else-if="source === 'custom'"
    v-bind="$attrs"
    :class="customIconClass"
  />
</template>
